"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    ACTIVE: {
        en: "Active",
        es: "Activo",
    },
    MANT: {
        en: "Hidden",
        es: "Ocultar",
    },
    MORA: {
        en: "Block",
        es: "Suspender",
    },
    CANCEL: {
        en: "Canceled",
        es: "Cancelado",
    },
    ACTIVE_DESC: {
        en: "Access to tracker. Saving data",
        es: "Con acceso, información guardada",
    },
    MANT_DESC: {
        en: "No access to tracker and Not Saving Data",
        es: "Sin acceso. Información no guardada",
    },
    MORA_DESC: {
        en: "No access to tracker and server is saving incoming data",
        es: "Sin acceso. Se esta guardando la informacion",
    },
    CANCEL_DESC: {
        en: "No access to tracker. Not saving data",
        es: "Sin acceso. Información no guardada",
    },
};
exports.default = translations;
